export default function isInIndia(latitude, longitude) {
    // India bounds
    const indiaBounds = {
        north: 37.6,
        south: 8.4,
        west: 68.1,
        east: 97.4
    };

    // Check if latitude and longitude are within India bounds
    if ((indiaBounds.south <= latitude && latitude <= indiaBounds.north) &&
        (indiaBounds.west <= longitude && longitude <= indiaBounds.east)) {
        return true;
    } else {
        return false;
    }
}
